import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "api/baseurl";
import MDInput from "components/MDInput";
import Pagination from "@mui/material/Pagination";
import { Tooltip } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Grid from "@mui/material/Grid";
import CardContent from "@mui/material/CardContent";
import Chip from "@mui/material/Chip";
import { toast } from "react-toastify";
import Divider from "@mui/material/Divider";
import "react-toastify/dist/ReactToastify.css";
import {
  TableContainer,
  Paper,
  Table,  Typography,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Modal,
  Card,
  IconButton,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { encryptBody } from "encryptionAndDecryption/bodyEncryption";
import { decryptBody } from "encryptionAndDecryption/bodyDecryption";
import { fetchSecretKey } from "encryptionAndDecryption/secretKeyDecryption";
import Box from "@mui/material/Box";
import { keyframes } from "@mui/system";
import MedicalAbstractBackground from "./MedicalAbstractBackground ";

function PatientPostConsultation() {
  const loginData = JSON.parse(localStorage.getItem("loginData"));
  const userid = loginData?.userid;
 
const [currentPage, setCurrentPage] = useState(0);
const [totalPages, setTotalPages] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(true);

  const [mappingDetails, setMappingDetails] = useState({
    doctorid: "",
    patientid: "",
    ccid: "",
    date: "",
  });

  const [mappingList, setMappingList] = useState([]);
  const navigate = useNavigate();
  const [openEditModal, setOpenEditModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");

  // 🔹 Add Modal
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);



  // 🔹 Delete Modal
  const handleOpenDeleteModal = (id) => {
    setSelectedId(id);
    setDeleteModal(true);
  };
  const handleCloseDeleteModal = () => setDeleteModal(false);

  // 🔹 Input change handler
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setMappingDetails((prevDetails) => ({ ...prevDetails, [name]: value }));
  };

  // 🔹 Delete Mapping
  const handleDelete = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const secretKey = await fetchSecretKey();
      const token = JSON.parse(localStorage.getItem("loginData"))?.token;

      const encryptedData = encryptBody({ id: selectedId }, secretKey);
 
      const response = await axios.post("/api/patientdoctormapping/delete", encryptedData, {
        headers: { "Content-Type": "text/plain", Authorization: `Bearer ${token}` },
      });

      if (response.status === 200) {
        const decryptedResponse = decryptBody(response.data, secretKey);
        toast.success(decryptedResponse.message || "Patient Doctor Mapping deleted successfully!");
        setDeleteModal(false);
        fetchMapping();
      }
    } catch (error) {
      toast.error(error.message || "Failed to delete mapping.");
    } finally {
      setLoading(false);
    }
  };

  // 🔹 Fetch All Mappings
  const fetchMapping = async (pageNumber = 1) => {
    try {
      const secretKey = await fetchSecretKey();
      const token = JSON.parse(localStorage.getItem("loginData"))?.token;
      if (!token) throw new Error("Authentication token not found.");

      const response = await axios.get(`/api/patientregistration/patient-summary-by-userid/${userid}`, {
        params: { page: Math.max(0, pageNumber - 1) },    
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
  
      
      if (response.status === 200) {
        const decryptedData = decryptBody(response.data, secretKey);
        setMappingList(decryptedData.content || []);
         setCurrentPage(decryptedData.number + 1);
          setTotalPages(decryptedData.totalPages);
      }
    } catch (error) {
      console.error("Error fetching mappings:", error);
    //   toast.error("Failed to fetch mappings.");
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   fetchMapping();
  // }, []);
 const handlePageChange = (_, pageNumber) => {
    setCurrentPage(pageNumber);
  };

  useEffect(() => {
    if (searchTerm) {
      setCurrentPage(); 
    }
  }, [searchTerm]);
  
  useEffect(() => {
    if (searchTerm) {
      searchData(currentPage); 
    } else {
      fetchMapping(currentPage);
    }
  }, [searchTerm, currentPage]);
  
const doctorInfo = mappingList.length > 0 ? mappingList[0].patient : null;

  const searchData = async (pageNumber = 1) => {
    setLoading(true);
     
      
        
       try {
         setLoading(true);
         const secretKey = await fetchSecretKey();
         const token = JSON.parse(localStorage.getItem("loginData")).token;
     
         const requestBody = encryptBody(
        {
           userid: doctorInfo.userid,
           
           searchTerm: searchTerm.trim(),
          
         },
         secretKey
        );
   
      const response = await axios.post("/api/patientdoctormapping/searchByPatientNameorDoctorName", 
        requestBody,
        {
            headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${token}`,
        },
      });
      console.log(response);
      if (response.status === 200) {
        const decryptedData = decryptBody(response.data, secretKey);
        console.log("Decrypted Search Response:", decryptedData); 
        setMappingList(decryptedData.content || []);
        setCurrentPage(decryptedData.number + 1);
        setTotalPages(decryptedData.totalPages);
      }
    } catch (error) {
      console.error("Error searching Care Coordinator:", error);
    } finally {
      setLoading(false);
    }
  };
  // Loader Animation
  const spinAnimation = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  `;
  const dotPositions = [
    { top: "5%", left: "50%" },
    { top: "20%", left: "80%" },
    { top: "50%", left: "95%" },
    { top: "80%", left: "80%" },
    { top: "95%", left: "50%" },
    { top: "80%", left: "20%" },
    { top: "50%", left: "5%" },
    { top: "20%", left: "20%" },
  ];

const labelStyle = {
  fontSize: "11px",
  fontWeight: 600,
  color: "#6B7280",
  textTransform: "uppercase",
  letterSpacing: "0.5px",
};

const valueStyle = {
  fontSize: "13px",
  color: "#111827",
  mt: 0.5,
  lineHeight: 1.6,
};
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MedicalAbstractBackground/>
      {/* Loader */}
      {loading && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            zIndex: 9999,
          }}
        >
          <Box
            sx={{
              position: "relative",
              width: 80,
              height: 80,
              animation: `${spinAnimation} 1.5s linear infinite`,
            }}
          >
            {dotPositions.map((pos, index) => (
              <Box
                key={index}
                sx={{
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  backgroundColor:"#1A237E",
                  position: "absolute",
                  ...pos,
                }}
              />
            ))}
          </Box>
        </Box>
      )}
<MDBox>

  {/* Clinical Records */}
  <Typography
    sx={{
      fontSize: "18px",
      fontWeight: 700,
      color: "#1A237E",
      mb: 2,
    }}
  >
    Clinical Records
  </Typography>

  <Grid container spacing={3}>
    {mappingList?.flatMap((item) =>
      item.clinicalRecords?.content?.map((record) => (
        <Grid item xs={12} sm={6} md={4} key={record.id}>
          <Card
            sx={{
              borderRadius: "12px",
              overflow: "hidden",
              border: "1px solid #E5E7EB",
              boxShadow: "0 2px 10px rgba(0,0,0,0.06)",
              height: "100%",
            }}
          >
            <Box
              sx={{
                bgcolor: "#1A237E",
                color: "#fff",
                px: 2,
                py: 1.5,
              }}
            >
              <Typography sx={{ fontSize: "14px", fontWeight: 600 }}>
                Clinical Record
              </Typography>
            </Box>

            <CardContent sx={{ p: 2 }}>
              <Box mb={2}>
                <Typography sx={labelStyle}>Diagnosis</Typography>
                <Typography sx={valueStyle}>
                  {record.diagnosis || "-"}
                </Typography>
              </Box>

              <Box mb={2}>
                <Typography sx={labelStyle}>Instructions</Typography>
                <Typography sx={valueStyle}>
                  {record.instructions || "-"}
                </Typography>
              </Box>

              <Box mb={2}>
                <Typography sx={labelStyle}>Decision</Typography>
                <Typography sx={valueStyle}>
                  {record.decision || "-"}
                </Typography>
              </Box>

              <Box mb={2}>
                <Typography sx={labelStyle}>Follow Up</Typography>
                <Typography sx={valueStyle}>
                  {record.followUp || "-"}
                </Typography>
              </Box>
               <Box mb={2}>
                <Typography sx={labelStyle}>Doctor Name</Typography>
                <Typography sx={valueStyle}>
                  {record.doctorName || "-"}
                </Typography>
              </Box>

              <Typography sx={labelStyle}>
                Medications
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 0.5,
                  mt: 1,
                }}
              >
                {record.medications?.length > 0 ? (
                  record.medications.map((med, i) => (
                    <Chip
                      key={i}
                      label={med}
                      size="small"
                      sx={{
                        bgcolor: "#EEF2FF",
                        color: "#1A237E",
                        fontSize: "11px",
                      }}
                    />
                  ))
                ) : (
                  <Typography sx={{ fontSize: "12px" }}>
                    No Medications
                  </Typography>
                )}
              </Box>

              <Divider sx={{ my: 2 }} />

              <Typography
                sx={{
                  fontSize: "11px",
                  color: "#757575",
                  textAlign: "right",
                }}
              >
                {record.createdAt
                  ? new Date(record.createdAt).toLocaleString()
                  : "-"}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      ))
    )}
  </Grid>

  <Box mt={2} display="flex" justifyContent="center">
                      <Pagination
                        count={totalPages}
                        page={currentPage}
                        onChange={handlePageChange}
                        color="success"
                         sx={{
                "& .MuiPaginationItem-root": {
                  borderRadius: "4px",
                  color: "#1A237E",          // Text color
                  borderColor: "#1A237E",    // Border color if outlined
                },
                "& .MuiPaginationItem-root.Mui-selected": {
                  backgroundColor: "#1A237E", // Selected background
                  color: "#fff",                 // Selected text color
                },
                "& .MuiPaginationItem-root:hover": {
                  backgroundColor: "#1A237E", // Slight hover effect
                },
              }}
                      />
                    </Box>

  {/* Post Consultations */}
  <Typography
    sx={{
      fontSize: "18px",
      fontWeight: 700,
      color: "#00897B",
      mt: 5,
      mb: 2,
    }}
  >
    Post Consultations
  </Typography>

  <Grid container spacing={3}>
    {mappingList?.flatMap((item) =>
      item.postConsultations?.content?.map((post) => (
        <Grid item xs={12} sm={6} md={4} key={post.id}>
          <Card
            sx={{
              borderRadius: "12px",
              overflow: "hidden",
              border: "1px solid #E5E7EB",
              boxShadow: "0 2px 10px rgba(0,0,0,0.06)",
              height: "100%",
            }}
          >
            <Box
              sx={{
                bgcolor: "#00897B",
                color: "#fff",
                px: 2,
                py: 1.5,
              }}
            >
              <Typography sx={{ fontSize: "14px", fontWeight: 600 }}>
                Post Consultation
              </Typography>
            </Box>

            <CardContent sx={{ p: 2 }}>
              <Box mb={2}>
                <Typography sx={labelStyle}>Clinical Notes</Typography>
                <Typography sx={valueStyle}>
                  {post.clinicalNotes || "-"}
                </Typography>
              </Box>

              <Box mb={2}>
                <Typography sx={labelStyle}>Care Plan</Typography>
                <Typography sx={valueStyle}>
                  {post.carePlan || "-"}
                </Typography>
              </Box>

              <Box mb={2}>
                <Typography sx={labelStyle}>Status</Typography>
                <Typography sx={valueStyle}>
                  {post.status || "-"}
                </Typography>
              </Box>

              <Box mb={2}>
                <Typography sx={labelStyle}>Decision</Typography>
                <Typography sx={valueStyle}>
                  {post.decision || "-"}
                </Typography>
              </Box>

              <Box mb={2}>
                <Typography sx={labelStyle}>Reading Frequency</Typography>
                <Typography sx={valueStyle}>
                  {post.readingFrequency || "-"}
                </Typography>
              </Box>
               <Box mb={2}>
                <Typography sx={labelStyle}>Doctor Name</Typography>
                <Typography sx={valueStyle}>
                  {post.doctorName || "-"}
                </Typography>
              </Box>

              <Typography sx={labelStyle}>
                Medications
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 0.5,
                  mt: 1,
                }}
              >
                {post.medications?.length > 0 ? (
                  post.medications.map((med, i) => (
                    <Chip
                      key={i}
                      label={med}
                      size="small"
                      sx={{
                        bgcolor: "#E8F5E9",
                        color: "#2E7D32",
                        fontSize: "11px",
                      }}
                    />
                  ))
                ) : (
                  <Typography sx={{ fontSize: "12px" }}>
                    No Medications
                  </Typography>
                )}
              </Box>

              <Divider sx={{ my: 2 }} />

              <Typography
                sx={{
                  fontSize: "11px",
                  color: "#757575",
                  textAlign: "right",
                }}
              >
                {post.createdAt
                  ? new Date(post.createdAt).toLocaleString()
                  : "-"}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      ))
    )}
  </Grid>

</MDBox>
 <Box mt={2} display="flex" justifyContent="center">
                      <Pagination
                        count={totalPages}
                        page={currentPage}
                        onChange={handlePageChange}
                        color="success"
                         sx={{
                "& .MuiPaginationItem-root": {
                  borderRadius: "4px",
                  color: "#1A237E",          // Text color
                  borderColor: "#1A237E",    // Border color if outlined
                },
                "& .MuiPaginationItem-root.Mui-selected": {
                  backgroundColor: "#1A237E", // Selected background
                  color: "#fff",                 // Selected text color
                },
                "& .MuiPaginationItem-root:hover": {
                  backgroundColor: "#1A237E", // Slight hover effect
                },
              }}
                      />
                    </Box>

      {/* Delete Modal */}
      <Modal open={deleteModal} onClose={handleCloseDeleteModal}>
        <Card sx={{ width: "400px", padding: 4, margin: "auto", mt: 15, textAlign: "center" }}>
          <MDTypography sx={{ mb: 3, fontSize: "16px", fontWeight: "bold" }}>
            Are you sure you want to delete this mapping?
          </MDTypography>
          <MDBox display="flex" justifyContent="space-around">
            <MDButton variant="gradient" onClick={handleDelete} sx={{ background: "red", color: "#fff" }}>
              Delete
            </MDButton>
            <MDButton
              variant="gradient"
              onClick={handleCloseDeleteModal}
              sx={{ background: "#1A237E", color: "#fff" }}
            >
              Cancel
            </MDButton>
          </MDBox>
        </Card>
      </Modal>
    </DashboardLayout>
  );
}

export default PatientPostConsultation;